'use client'
import { ToastProvider as HeroToastProvider, addToast } from '@heroui/react'
import { TOAST_LAYER_CLASS } from "@/ui/modalLayer"

export const useToast = () => {
  return {
    showToast: ({ type = "default", message }) => {
      addToast({
        description: message,
        color: type === 'error' ? 'danger' : type,
      })
    }
  }
}

export const ToastProvider = () => (
  <HeroToastProvider
    placement="bottom-right"
    regionProps={{
      className: TOAST_LAYER_CLASS,
    }}
  />
) 